module.exports = __webpack_public_path__ + "img/wximg27.526d2267.png";